module.exports = "<nav class=\"navbar navbar-dark menu-bar\">\n  <div class=\"container\" id=\"content-container\">\n    <span class=\"navbar-brand\">Őszi fenyőfa csemeték 2017</span>\n  </div>\n</nav>\n"


//////////////////
// WEBPACK FOOTER
// /Users/manuel/Sites/doxasoft/fenyofarm/csemete/src/app/menu-bar/menu-bar.component.html
// module id = ../../../../../src/app/menu-bar/menu-bar.component.html
// module chunks = main